import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";

const ICONS = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
};

export default function Toasts({ toasts }) {
  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((toast) => {
        const Icon = ICONS[toast.type] || Info;
        return (
          <div key={toast.id} className={`toast toast-${toast.type}`}>
            <Icon size={17} strokeWidth={2.2} />
            <span>{toast.message}</span>
            <button
              type="button"
              className="icon-btn toast-close"
              aria-label="关闭提示"
              onClick={() => toast.onClose?.()}
            >
              <X size={15} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
